import type { TrackingItem } from '@/api/generated';

import { OrderItemRow } from './OrderItemRow.tsx';
import { TrackingCard } from './TrackingCard.tsx';

type OrderSummaryCardProps = {
  items: TrackingItem[];
};

export function OrderSummaryCard({ items }: OrderSummaryCardProps) {
  if (items.length === 0) return null;

  return (
    <TrackingCard
      title="Order summary"
      subtitle={
        <p className="text-sm text-muted-foreground">
          {items.length} {items.length === 1 ? 'item in this order' : 'items in this order'}
        </p>
      }
    >
      <div className="flex flex-col gap-4">
        {items.map((item, i) => (
          <OrderItemRow
            key={i}
            title={item.title ?? 'Untitled item'}
            quantity={item.quantity}
            image={item.image}
          />
        ))}
      </div>
    </TrackingCard>
  );
}
